"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    content: _propTypes.array.isRequired,
    open: _propTypes.bool,
    productId: _propTypes.string,
    redirect: _propTypes.string,
    backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string
  },
  DefaultProps: {
    open: true,
    backgroundColor: _constant2.CHN_DISCLAIMER_DEFAULTS.BACKGROUND_COLOR,
    productId: _constant2.CHN_DISCLAIMER_DEFAULTS.PRODUCT_ID,
    accessible: true,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;